import React from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb';

import portfolioImg1 from '../../assets/img/project/inner-1-1.jpg';
import portfolioImg2 from '../../assets/img/project/inner-1-2.jpg';
import portfolioImg3 from '../../assets/img/project/inner-1-3.jpg';
import portfolioImg4 from '../../assets/img/project/inner-1-4.jpg';
import portfolioImg5 from '../../assets/img/project/inner-1-5.jpg';
import portfolioImg6 from '../../assets/img/project/inner-1-6.jpg';
import portfolioImg7 from '../../assets/img/project/inner-1-7.jpg';
import portfolioImg8 from '../../assets/img/project/inner-1-8.jpg';

const PortfolioMain = () => {
  // Portfolio items
  const items = [
    {
      id: 1,
      portfolioImage: portfolioImg1,
      subtitle: 'Clinic',
      title: 'Home Visit',
    },
    {
      id: 2,
      portfolioImage: portfolioImg2,
      subtitle: 'Clinic',
      title: 'Home Visit',
    },
    {
      id: 3,
      portfolioImage: portfolioImg3,
      subtitle: 'Clinic',
      title: 'Home Visit',
    },
    {
      id: 4,
      portfolioImage: portfolioImg4,
      subtitle: 'Clinic',
      title: 'Home Visit',
    },
    {
      id: 5,
      portfolioImage: portfolioImg5,
      subtitle: 'Clinic',
      title: 'Home Visit',
    },
    {
      id: 6,
      portfolioImage: portfolioImg6,
      subtitle: 'Clinic',
      title: 'Home Visit',
    },
    {
      id: 7,
      portfolioImage: portfolioImg7,
      subtitle: 'Clinic',
      title: 'Home Visit',
    },
    {
      id: 8,
      portfolioImage: portfolioImg8,
      subtitle: 'Clinic',
      title: 'Home Visit',
    },
  ];

  return (
    <main>
      <Breadcrumb title="Portfolio" />

      <div className="it-portfolio-area pt-120 pb-90">
        <div className="container">
          <div className="row gx-35">
            {items.map((item) => (
              <div
                key={item.id}
                className="col-xl-3 col-lg-4 col-md-4 col-sm-6 mb-35"
              >
                <div className="it-portfolio-item fix p-relative">
                  <div className="it-portfolio-thumb">
                    <img src={item.portfolioImage} alt="" />
                  </div>
                  <div className="it-portfolio-content">
                    <span>{item.subtitle}</span>
                    <h4 className="it-portfolio-title">
                      <Link
                        className="hover-anim black"
                        to="/portfolio-details"
                      >
                        {item.title}
                      </Link>
                    </h4>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="it-pagination text-center mt-30">
                <nav>
                  <ul>
                    <li>
                      <Link to="#">1</Link>
                    </li>
                    <li className="current">
                      <Link to="#">2</Link>
                    </li>
                    <li>
                      <Link to="#">3</Link>
                    </li>
                    <li>
                      <Link className="current" to="#">
                        <i className="fa-solid fa-arrow-right-long"></i>
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default PortfolioMain;
